/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Upload_Failed_SomeInputs */

const en_doc_upload_failed_some = /** @type {(inputs: Doc_Upload_Failed_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some documents failed to upload. You can re-upload them in the details page.`)
};

const pt_br2_doc_upload_failed_some = /** @type {(inputs: Doc_Upload_Failed_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alguns documentos falharam no envio. Você pode reenviá-los na página de detalhes.`)
};

/**
* | output |
* | --- |
* | "Some documents failed to upload. You can re-upload them in the details page." |
*
* @param {Doc_Upload_Failed_SomeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_upload_failed_some = /** @type {((inputs?: Doc_Upload_Failed_SomeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Upload_Failed_SomeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_upload_failed_some(inputs)
	return pt_br2_doc_upload_failed_some(inputs)
});